import { render } from "./SectionPrize.vue?vue&type=template&id=69d68d1c"
import script from "./SectionPrize.vue?vue&type=script&lang=js"
export * from "./SectionPrize.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__